<script>
import DepartmentChoose from "@/view/components/DepartmentChoose.vue";
import BankSearch from "@/view/components/BankSearch.vue";
import uploadImg from "@/components/uploadImg/index.vue";
import urlConfig from "@/utils/urlConfig";
import {commonDict} from "@/utils/bizDict/commonDict";
import {BizDictCascade} from "@/utils/bizDict/kvMap";

const token = () => sessionStorage.getItem("token");
export default {
  name: "personReg",
  components: {uploadImg, BankSearch, DepartmentChoose},
  data() {
    return {
      // 职业列表
      OcpCdlist: BizDictCascade.OcpCd,
      formData: {
        deptId: undefined,
        deptCode: '',
        channelNo: '',
        appNo: '',
        accountName: '',
        accountProperty: '1',
        mobile: '',
        primaryAccount: '',
        bankNo: '',
        bankName: '',
        idType: '',
        idNo: '',
        idAddress: '',
        signName: '',
        signNo: '',
        idStartDate: '',
        idEndDate: '',
        job: '',
        jobNote: '',
        files: []
      },
      currentStep: 1,
      totalSteps: 5,
      progress: 0,
      stepStatus: Array(5).fill('wait'),
      stepTitles: ["渠道信息", "个人信息", "证件信息", "信息确认", "完成提交"],
      rules: {},
      allRules: {
        1: {
          channelNo: [{required: true, message: '请输入渠道编号', trigger: 'blur'}],
          // appNo: [{ required: true, message: '请输入应用编号', trigger: 'blur' }],
          deptId: [{required: true, message: '请选择机构', trigger: 'blur'}],
        },
        2: {

          mobile: [
            {required: true, message: '请输入手机号', trigger: 'blur'},
            {pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur'},
          ],
          primaryAccount: [
            {required: true, message: '请输入银行卡号', trigger: 'blur'},
            {pattern: /^\d{16,19}$/, message: '银行卡号格式不正确', trigger: 'blur'}
          ],
          job: [{required: true, message: '请输入职业', trigger: 'blur'}],
        },
        3: {
          accountName: [{required: true, message: '请输入账户名称', trigger: 'blur'}],
          idType: [{required: true, message: '请选择证件类型', trigger: 'change'}],
          idNo: [{required: true, message: '请输入证件号码', trigger: 'blur'}],
          idStartDate: [{required: true, message: '请选择有效期起', trigger: 'change'}],
          idEndDate: [{required: true, message: '请选择有效期止', trigger: 'change'}],
        }
      },

      // 核心企业列表
      companylist: [],

      headers: {token: token()},
      busiURL: urlConfig.busiURL + "/base/ocr/recognizeIdcard",

      loading: false,
      // 正反面状态
      frontImgVisible: false,
      frontImgFile: "",
      frontImgFilePath: "",
      frontImgEditing: false,

      backImgVisible: false,
      backImgFile: "",
      backImgFilePath: "",
      backImgEditing: false,
    };
  },
  computed: {

    commonDict() {
      return commonDict
    },
    currentRules() {
      return this.allRules[this.currentStep] || {};
    },
    progressColor() {
      if (this.progress < 30) return '#ff4d4f';
      if (this.progress < 70) return '#faad14';
      return '#52c41a';
    },
    isLastStep() {
      return this.currentStep === 4;
    },
    isFirstStep() {
      return this.currentStep === 1;
    }
  },


  watch: {
    currentStep(newVal) {
      this.updateProgress();
      this.stepStatus = this.stepStatus.map((_, index) => {
        if (index < newVal - 1) return 'finish';
        if (index === newVal - 1) return 'process';
        return 'wait';
      });
    },
    formData: {
      deep: true,
      handler() {
        this.updateProgress();
      }
    }
  },
  created() {
    this.getChannelList();
  },
  methods: {
    isJobOther() {
      return this.formData.job === '其他';
    },
    //上传前图片压缩或拦截
    handleBeforeUpload(file) {
      const isOverSize = file.size / 1024 / 1024 > 1;
      if (isOverSize) {
        return this.compressImage(file); // 返回 Promise
      }
      return true;
    },


    changeIdUp(info) {
      this.$refs['IdUp'].handleChangeUpload(info, "");
    },
    changeIdBack(info) {
      console.log("changeIdBack info", info)
      this.$refs['IdBack'].handleChangeUpload(info, "");
    },

    completedUpload(ocrInfo) {
      console.log("completedUpload ocrInfo", ocrInfo)
      const channel_file_no = ocrInfo.data.channel_file_no;
      const file_no = ocrInfo.data.file_no;
      const file_path = ocrInfo.data.file_path;
      const ocrRecognizeResult = ocrInfo.data.ocrRecognizeResult;

      if (ocrRecognizeResult.validDate) {
        // 国徽面
        this.formData.signName = ocrRecognizeResult.authority;
        this.formData.idStartDate = ocrRecognizeResult.validDate.substr(0, 10).replace(/(\d{4})\D*(\d{2})\D*(\d{2})/, "$1-$2-$3");
        this.formData.idEndDate = ocrRecognizeResult.validDate.includes('长期') ? "9999-12-31" : ocrRecognizeResult.validDate.substr(11, 10).replace(/(\d{4})\D*(\d{2})\D*(\d{2})/, "$1-$2-$3");
        //先移除 fileType===01旧数据
        this.formData.files = this.formData.files.filter(file => file.fileType !== "01");
        this.formData.files.push({
          fileNo: file_no,
          fileType: "01",
          fileUrl: file_path,
          channelFileNo: channel_file_no,
        });
      } else {
        // 人像面
        this.formData.accountName = ocrRecognizeResult.name;
        this.formData.idNo = ocrRecognizeResult.idcard;
        this.formData.birthdt = ocrRecognizeResult.birth.replace('年', '-').replace('月', '-').replace('日', '');
        this.formData.sex = ocrRecognizeResult.sex === '女' ? '2' : '1';
        this.formData.idAddress = ocrRecognizeResult.address
        let res = this.api.addressNormalization(ocrRecognizeResult.address)
        if (res.code === 200) {
          let area = this.busiDict.DstcCd.find(prov => prov.label === res.data.prov)
              ?.children.find(city => city.label === res.data.city)
              ?.children.find(district => district.label === res.data.district)
          this.formData.signNo = area.value
        }
        //先移除 fileType===02旧数据
        this.formData.files = this.formData.files.filter(file => file.fileType !== "02");
        this.formData.files.push({
          fileNo: file_no,
          fileType: "02",
          fileUrl: file_path,
          channelFileNo: channel_file_no,
        });
      }

      console.log("completedUpload formData.files ", this.formData.files)
    },


    // 获取核心企业列表
    async getChannelList() {
      const res = await this.api.coreCompanyInfoApi();
      if (res.code !== 200) {
        this.$message.error(res.info);
        return;
      }

      this.companylist = []
      res.data.forEach((item) => {
        this.companylist.push({
          label: item.channelName + "（" + item.channelNo + "）",
          value: item.channelNo,
          info: item,
        });
      });
      if (this.companylist.length === 1) {
        this.form.channel_no = this.companylist[0]?.value
        this.channel_nochange(this.form.channel_no)
      }
    },
    channelChange(val) {
      this.companylist.forEach((item) => {
        if (Number(val) == Number(item.value)) {
          this.formData.appNo = item.info.appNo;
        }
      });
    },
    getStepCompletion(step) {
      switch (step) {
        case 1:
          return this.formData.channelNo && this.formData.appNo && this.formData.deptId ? 20 : 0;
        case 2:
          return this.formData.mobile && this.formData.primaryAccount ? 30 : 0;
        case 3:
          return this.formData.accountName && this.formData.idType && this.formData.idNo && this.formData.idStartDate && this.formData.idEndDate && this.formData.files.length > 0 ? 50 : 0;
        default:
          return 0;
      }
    },
    updateProgress() {
      const stepProgress = ((this.currentStep - 1) / this.totalSteps) * 80;
      const stepCompletion = this.getStepCompletion(this.currentStep);
      this.progress = Math.min(100, stepProgress + stepCompletion);
    },

    nextStep() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.currentStep++;
          console.log("第"+this.currentStep+"步骤验证成功", this.formData)
        } else {
          this.$message.error("请完整填写当前步骤表单信息");
        }
      });
    },


    prevStep() {
      if (this.currentStep > 1) this.currentStep--;
    },


    beforeUpload(file) {
      const isValidType = ['image/jpeg', 'image/png', 'application/pdf'].includes(file.type);
      const isValidSize = file.size / 1024 / 1024 < 10;
      if (!isValidType) {
        this.$message.error('仅支持 JPG/PNG/PDF 文件');
        return false;
      }
      if (!isValidSize) {
        this.$message.error('文件大小不能超过 10MB');
        return false;
      }
      return true;
    },
    async submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          console.log('提交数据：', this.formData); // 可替换为API调用

          try {
            const rsp = await this.api.addAcctReg(this.formData);
            if (rsp.code !== 200) {
              this.$message.error(rsp.info);
              return;
            }
            // 成功后进入第五步
            this.nextStep();
          } catch (e) {
            console.error(e);
            this.$message.error('提交失败，请稍后再试');
          }
        } else {
          this.$message.error('请填写必填字段');
        }
      });
    },

    goHome() {
      this.$router.push("/cust/acctregPage");
    },
    newApplication() {
      this.$refs.form.resetFields();
      this.formData.files = [];
      this.currentStep = 1;
      this.progress = 0;
      this.stepStatus = Array(5).fill('wait');
    },
    previewFile(file) {
      if (file.fileUrl) {
        window.open(file.fileUrl, '_blank');
      } else {
        this.$message.warning('无法预览：附件未上传或未生成预览链接');
      }
    },
    isImage(url) {
      return /\.(jpeg|jpg|gif|png|bmp|webp)$/i.test(url);
    },

  },
  mounted() {
    // 初始状态
    this.currentStep = 1;
  }
};
</script>


<template>
  <div class="registration-container">
    <!-- 页面标题 -->
    <a-page-header
        title="开户登记申请"
        sub-title="请按照步骤填写开户信息"
        @back="goHome"
        class="page-header"
    >
      <template #extra>
        <a-button type="primary"  @click="goHome">返回</a-button>
      </template>
    </a-page-header>

    <!-- 进度条 -->
    <div class="progress-container">
      <a-progress
          :percent="progress"
          :stroke-color="progressColor"
          :show-info="false"
          class="progress-bar"
      />
      <div class="progress-info">
        <span class="progress-text">完成进度: {{ progress }}%</span>
      </div>
    </div>

    <!-- 步骤条 -->
    <div class="steps-container">
      <a-steps :current="currentStep - 1">
        <a-step v-for="(title, index) in stepTitles" :key="index" :title="title" :status="stepStatus[index]"/>
      </a-steps>
    </div>

    <!-- 表单 -->
    <a-form-model
        ref="form"
        :model="formData"
        :rules="currentRules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 14 }"
        class="account-form"
    >
      <!-- 步骤 1 -->
      <div v-show="currentStep === 1">
        <a-form-model-item label="所属机构" prop="deptId">
          <DepartmentChoose :department-id.sync="formData.deptId" :department-code.sync="formData.deptCode" :default-first="false"/>
        </a-form-model-item>

        <a-form-model-item label="渠道归属" prop="channelNo">
          <a-select v-model="formData.channelNo" @change="channelChange" placeholder="请选择核心企业">
            <a-select-option v-for="item in companylist" :key="item.value" :value="item.value">
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </div>

      <!-- 步骤 2 -->
      <div v-show="currentStep === 2">
        <a-form-model-item label="手机号" prop="mobile">
          <a-input v-model="formData.mobile" placeholder="请输入手机号"/>
        </a-form-model-item>
        <a-form-model-item label="银行卡号" prop="primaryAccount">
          <a-input v-model="formData.primaryAccount" placeholder="请输入银行卡号"/>
        </a-form-model-item>
        <a-form-model-item label="开户银行/网点" prop="bankNo">
          <BankSearch :bankNo.sync="formData.bankNo" :bankName.sync="formData.bankName"/>
        </a-form-model-item>
        <a-form-model-item label="职业" prop="job">

          <el-cascader v-model="formData.job" placeholder="请选择职业" :options="OcpCdlist"
                       :props="{ emitPath: false }" :show-all-levels="false">
          </el-cascader>
        </a-form-model-item>
        <a-form-model-item label="职业备注" prop="jobNote">
          <a-input v-model="formData.jobNote" placeholder="请输入职业备注"/>
        </a-form-model-item>

      </div>

      <!-- 步骤 3 -->
      <div v-show="currentStep === 3">
        <a-form-model-item ref="name" class="pricebox" label="证照照片">
          <div style="color:red">上传证件照 进行识别</div>
          <div class="row">
            <div class="item">
              <span style="margin-right: 20px; display: inline-block; width: 100px">人像面</span>
              <a-upload
                  accept="image/*"
                  :before-upload="handleBeforeUpload"
                  name="file"
                  ref="uploadRef"
                  list-type="picture-card"
                  class="avatar-uploader"
                  :show-upload-list="false"
                  :action="busiURL"
                  :headers="headers"
                  @change="changeIdUp"
              >
                <uploadImg
                    v-show="frontImgVisible"
                    ref="IdUp"
                    @completedUpload="completedUpload"
                    @onloadsuccsse="frontImgVisible = $event"
                    @fileData="frontImgFile = $event"
                    @filePath="frontImgFilePath = $event"
                    :showEditicon="true"
                />
                <div v-show="!frontImgVisible">
                  <a-icon v-if="!loading" type="plus"/>
                  <a-spin v-else/>
                </div>
              </a-upload>

            </div>
            <div class="item">
              <span style="margin-right: 20px; display: inline-block; width: 100px">国徽面</span>
              <a-upload
                  accept="image/*"
                  :before-upload="handleBeforeUpload"
                  name="file"
                  ref="uploadRef"
                  list-type="picture-card"
                  class="avatar-uploader"
                  :show-upload-list="false"
                  :action="busiURL"
                  :headers="headers"
                  @change="changeIdBack"
              >
                <uploadImg
                    v-show="backImgVisible"
                    ref="IdBack"
                    @completedUpload="completedUpload"
                    @onloadsuccsse="backImgVisible = $event"
                    @fileData="frontImgFile = $event"
                    @filePath="frontImgFilePath = $event"
                    :showEditicon="true"
                />
                <div v-show="!backImgVisible">
                  <a-icon v-if="!loading" type="plus"/>
                  <a-spin v-else/>
                </div>
              </a-upload>

            </div>
          </div>
        </a-form-model-item>

        <a-form-model-item label="账户名称" prop="accountName">
          <a-input v-model="formData.accountName" placeholder="请输入账户名称"/>
        </a-form-model-item>
        <a-form-model-item label="证件类型" prop="idType">
          <a-select v-model="formData.idType" placeholder="请选择证件类型">
            <a-select-option v-for="(item, key) in commonDict.idTypeList" :key="key" :value="key">
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="证件号码" prop="idNo">
          <a-input v-model="formData.idNo" placeholder="请输入证件号码"/>
        </a-form-model-item>
        <a-form-model-item label="有效期起" prop="idStartDate">
          <a-date-picker v-model="formData.idStartDate" style="width: 100%"/>
        </a-form-model-item>
        <a-form-model-item label="有效期止" prop="idEndDate">
          <a-date-picker v-model="formData.idEndDate" style="width: 100%"/>
        </a-form-model-item>
      </div>

      <!-- 步骤 4 确认 -->
      <div v-show="currentStep === 4">
        <a-descriptions :title="formData.accountName || '信息确认'" bordered>
          <a-descriptions-item label="名字">
            {{ formData.accountName || '-' }}
          </a-descriptions-item>
          <a-descriptions-item label="证件类型">
            {{ (commonDict.idTypeList[formData.idType]?.label) || '-' }}
          </a-descriptions-item>
          <a-descriptions-item label="证件号码">
            {{ formData.idNo || '-' }}
          </a-descriptions-item>

          <a-descriptions-item label="性别">
            {{ (commonDict.sexList[formData.sex]?.label) || '-' }}
          </a-descriptions-item>

          <a-descriptions-item label="证件有效起始日期">
            {{ formData.idStartDate || '-' }}
          </a-descriptions-item>
          <a-descriptions-item label="证件有效结束日期">
            {{ formData.idEndDate || '-' }}
          </a-descriptions-item>

          <a-descriptions-item label="签发机关名称">
            {{ formData.signName || '-' }}
          </a-descriptions-item>
          <a-descriptions-item label="签发机关编号">
            {{ formData.signNo || '-' }}
          </a-descriptions-item>
          <a-descriptions-item label="证件地址">
            {{ formData.idAddress || '-' }}
          </a-descriptions-item>

          <a-descriptions-item label="职业">
            {{ formData.job || '-' }}
          </a-descriptions-item>
          <a-descriptions-item label="职业备注">
            {{ formData.jobNote || '-' }}
          </a-descriptions-item>

          <a-descriptions-item label="附件" :span="3">
            <div class="file-thumbnails">
              <div
                  v-for="file in formData.files"
                  :key="file.fileNo"
                  class="thumbnail-container"
                  @click="previewFile(file)"
              >
                <img
                    v-if="isImage(file.fileUrl)"
                    :src="file.fileUrl"
                    alt="附件缩略图"
                    class="thumbnail-image"
                />
                <div v-else class="thumbnail-pdf">
                  <a-icon type="file-pdf" style="font-size: 36px; color: #d32f2f"/>
                  <div style="font-size: 12px; color: #666; margin-top: 4px;">
                    PDF预览
                  </div>
                </div>
              </div>
              <div v-if="!formData.files || !formData.files.length">
                暂无附件
              </div>
            </div>
          </a-descriptions-item>
        </a-descriptions>

      </div>

      <!-- 步骤 5 提交完成 -->
      <!-- 完成提交 -->
      <div v-show="currentStep === 5">
        <a-result
            status="success"
            title="开户申请提交成功"
            sub-title="系统将在1-3个工作日完成审核，请耐心等待"
        >
          <template #extra>
            <a-button type="primary" @click="newApplication">新申请</a-button>
          </template>
        </a-result>
      </div>

      <div v-show="currentStep < 5" class="step-btn-bar">
        <a-button v-if="currentStep > 1" @click="prevStep">上一步</a-button>
        <a-button type="primary" @click="currentStep < 4 ? nextStep() : submitForm()">
          {{ (currentStep < 4) ? "下一步" : "提交申请" }}
        </a-button>
      </div>
    </a-form-model>
  </div>
</template>


<style scoped lang="less">
.step-btn-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
  margin-bottom: 24px;
}
.registration-container {
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);

  .page-header {
    background: transparent;
    padding: 0;
    margin-bottom: 20px;
  }

  .progress-container {
    margin-bottom: 30px;
    position: relative;

    .progress-bar {
      border-radius: 8px;
      overflow: hidden;
    }

    .progress-info {
      display: flex;
      justify-content: space-between;
      margin-top: 8px;

      .progress-text {
        font-size: 14px;
        color: #595959;
        font-weight: 500;
      }
    }
  }

  .steps-container {
    margin-bottom: 30px;

    /deep/ .ant-steps-item-process .ant-steps-item-icon {
      background: #1890ff;
      border-color: #1890ff;
    }

    /deep/ .ant-steps-item-finish .ant-steps-item-icon {
      background-color: #fff;
      border-color: #1890ff;

      .ant-steps-icon {
        color: #1890ff;
      }
    }
  }

  .account-form {
    padding: 20px;
    background: #fafafa;
    border-radius: 4px;
    border: 1px solid #f0f0f0;

    .form-step {
      margin-bottom: 24px;
      padding: 24px;
      background: #fff;
      border-radius: 4px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

      .step-title {
        font-size: 16px;
        font-weight: 600;
        color: #1890ff;
        margin-bottom: 24px;
        padding-bottom: 12px;
        border-bottom: 1px solid #e8f3ff;
      }
    }

    .success-step {
      text-align: center;
      padding: 40px 20px;
    }

    .file-section {
      padding: 20px;
      background: #fff;
      border-radius: 4px;
      border: 1px dashed #d9d9d9;

      .file-info {
        margin-top: 16px;
        font-size: 13px;
        color: #8c8c8c;
      }
    }

    .form-actions {
      margin-top: 30px;
      text-align: center;
      padding-top: 20px;
      border-top: 1px solid #e8e8e8;
    }
  }
}

.row {
  display: flex;
  margin-top: 25px;

  .item {
    margin-left: 50px;
    display: flex;
    // width: 600px;
    align-items: center;

    /deep/ .ant-upload {
      width: 200px;
      height: 122px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      cursor: pointer;
      padding: 0px;
      overflow: hidden;

      border: 1px dashed #d9d9d9 !important;
      background-color: #fafafa !important;

      .anticon-plus {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .ant-upload.ant-upload-select-picture-card {
      border: 1px solid #ccc;
    }

    .ant-upload.ant-upload-select-picture-card > .ant-upload {
      padding: 0;
    }

    .ant-upload-select-picture {
      width: 200px;
      height: 122px;
      border: 0;
    }
  }
}

.file-thumbnails {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.thumbnail-container {
  width: 80px;
  height: 80px;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border 0.2s;
}

.thumbnail-container:hover {
  border-color: #1890ff;
}

.thumbnail-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.thumbnail-pdf {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

</style>